import React, { useCallback } from 'react';
import { Box, CheckBox, Text, useWatch } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { RoleLevel } from '@/modules/role/role.types';




interface Props {
  isEditMode?: boolean;
  children: React.ReactNode;
  value?: boolean;
  onChangeValue: (value: boolean) => void;
  
}
const AllowCreateAnotherRole: React.FC<Props> = ({children, isEditMode, value = false, onChangeValue }) => {
  const handleToggleCheck = useCallback(() => {
    onChangeValue(!value);
  }, [onChangeValue, value]);

  const roleLevel = useWatch({
    name: 'level',
  }) as RoleLevel;

  if (!value && !isEditMode) {
    return <Text data-testid="allow-create-another-role_empty">{EMPTY_FIELD_VALUE}</Text>;
  }
  if(isEditMode) {
    return (
      <Box direction='column' fill>
        <Box margin={{ bottom: 's' }}>
          <CheckBox data-testid="allow-create-another-role" checked={value} onChange={handleToggleCheck} disabled={!roleLevel} />
        </Box>
        {value ? children: null}
      </Box>
    );
  }

  

  return (
    <Box direction="column">
      <Box margin={{ bottom: 's' }}>
        <CheckBox data-testid="allow-create-another-role" checked={value} disabled />
      </Box>
      {value ? children: null}
      
    </Box>
  );
};

export default AllowCreateAnotherRole;
